import { Component, EventEmitter, Output } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';
import { QnSbnDataServiceService } from '../../services/qn-sbn-data-service.service';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileUploadSingleComponent } from '../../create-notification/file-upload/file-upload-single/file-upload-single.component';
import { LSOAcknowledgementNoticeComponent } from '../lsoacknowledgement-notice/lsoacknowledgement-notice.component';

@Component({
  selector: 'dl-lso-acknowledgement',
  standalone: true,
  imports: [OneWebComponentsAngularModule,LSOAcknowledgementNoticeComponent,FileUploadSingleComponent,ReactiveFormsModule,FormsModule],
  templateUrl: './lso-acknowledgement.component.html',
  styleUrl: './lso-acknowledgement.component.scss'
})
export class LsoAcknowledgementComponent {
  public commentText = new FormControl('');
  visibleLsoacknowledgement: boolean = false;
  public storedData;
  public ackData: any;
  
  @Output() closed = new EventEmitter<{ ackComment: string; ackFile: any[] } | null>();
  constructor(
    public _QnSbnDataService:QnSbnDataServiceService,
  ) { }

  ngOnInit(): void {
    this._QnSbnDataService.mappingData$.subscribe(storeData=>{
      this.storedData = storeData;
    })
  }

  sendAckDetails(): void {
    this.visibleLsoacknowledgement = true;
  }

 
  onNoticeDialogClose(res: any): void {
    this.visibleLsoacknowledgement = false;
    
    if (res == 'false') {
      return;
    } else {
      let fileData = this._QnSbnDataService.fileUploadData(this.storedData);
      this.ackData = {
        ackComment: this.commentText.value,
        ackFile: fileData || [],
      };
      this.closed.emit(this.ackData);
    }
  }

 
  cancel(): void {
    this.closed.emit(null);
  }
}